import React from 'react';

import { Alert } from 'react-bootstrap';

import { IconExclamationCircle, IconX } from '@tabler/icons-react';

const BillingNotificationItem = (props) => {
  const { notification, updateNotificationStatus } = props;

  return (
    <Alert key={notification.id} variant="secondary">
      <div className="custom-alert-area">
        <div className="text-area">
          <IconExclamationCircle className="me-3" stroke={1.5} />
          <div className="text">
            <small>{notification.message}</small>
          </div>
        </div>
        <div>
          <span
            className="close"
            onClick={() => updateNotificationStatus(notification.id, notification.is_read !== true)}
          >
            <IconX stroke={1.5} />
          </span>
        </div>
      </div>
    </Alert>
  );
};

export default BillingNotificationItem;
